import Bugsnag from "@bugsnag/js";
import { COOKIES } from "../constants";
import Cookies from "../utilities/cookies";
import { APIError } from "../utilities/errors";
import { useLocale } from "../hooks/useLocale/useLocale";

const API = class {
  constructor() {
    // eslint-disable-next-line no-undef
    this.url = process.env.REACT_APP_API_URL;
  }

  async request(path, { body, headers, method = "GET" } = {}) {
    const authorization = Cookies.get({ name: COOKIES.AUTHORIZATION });
    const locale = useLocale();

    let url = `${this.url}${path}`;

    if (method.toUpperCase() === "GET" && locale) {
      const urlObj = new URL(url, window.location.origin);
      urlObj.searchParams.set("locale", locale);
      url = urlObj.toString();
    } else if (body && typeof body === "object") {
      // If method is not GET, add locale inside body
      body = { ...body, locale };
    }

    const options = {
      headers: {
        Accept: "application/json",
        "Access-Control-Allow-Origin": "*",
        Authorization: authorization,
      },
      method,
    };

    // Check if the body is a FormData instance or other binary data
    if (body instanceof FormData) {
      options.body = body;
      // Let the browser set the `Content-Type` for FormData
      delete options.headers["Content-Type"];
    } else if (body) {
      options.body = JSON.stringify(body);
      options.headers["Content-Type"] = "application/json";
    }

    // Merge additional headers
    if (headers) {
      options.headers = { ...options.headers, ...headers };
    }

    const promise = fetch(url, options);

    promise
      .then((response) => {
        if (response.status >= 300 && response.status != 422) {
          response
            .json()
            .then((body) => {
              const apiError = new APIError({ response: response, body: body });
              Bugsnag.notify(apiError);
              return { response: response, body: body };
            })
            .catch((error) => {
              const apiError = new APIError({
                response: response,
                body: error,
              });
              Bugsnag.notify(apiError);
            });
        }
      })
      .catch(console.log);

    return promise;
  }
};

export default API;
